export default __webpack_public_path__ + "static/cr_thumb-cc95024022141e22b7cb5c515a5b301d.png";